<template>
  <card>
    <list 
      v-if="$store.state.user.is_root" 
      :columns="columns" 
      :modalCreate="modalCreate" 
      :removeLink="removeLink"
      :cardLink="cardLink" 
      :isUpdate="true" 
      :isAdd="true" 
      :itemLink="itemLink" 
      :setLink="setLink" 
      :openItem="true"
      :fields="fields" 
      :searchDisable="false" 
      @change="change" 
      @changeFunction="changeFunction" 
      v-model="val" />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      modalCreate: "discipline",
      fields: [
        {
          label: "Группа предметов",
          key: "category",
          type: "select",
          selectKey: "title",
          modal: "category",
          prefix: "category_pref",
        },
        {
          key: "title",
          label: "Название",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
        {
          col: 'col-6 col-md-6',
          key: "icon",
          label: "Лого",
          type: "img",
          textType: "",
          MAX_WIDTH: '200',
          secondKey: 'color'
        },
        {
          col: 'col-12 col-md-6',
          key: "color",
          label: "Цвет",
          type: "field",
          textType: "color",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_discipline",
      itemLink: "disciplines",
      setLink: "disciplines",
      columns: [
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "category",
          object: "title",
          title: "Группа предметов",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
